export default __webpack_public_path__ + "static/media/se.c2c75c2c.jpg";